import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Point } from "services/sale/common/types";

interface LocationType {
  caption?: string;
  point: Point;
}
interface SaleMap {
  mapRef?: any;
  center: Point;
  isDraggable?: boolean;
  address: string;
  pointId?: number;
  isOutofService?: boolean;
  isPickingOnMap?: boolean;
  selectedLocations: LocationType;
}

const initialState: SaleMap = {
  center: null!,
  isDraggable: true,
  address: "",
  isOutofService: false,
  isPickingOnMap: false,
  selectedLocations: {
    caption: null!,
    point: null!,
  },
};

const mapSlice = createSlice({
  name: "mapSlice",
  initialState: initialState,
  reducers: {
    clearData: (state, action) => {
      state = {
        // mapRef: null!,
        center: null!,
        isDraggable: true,
        address: "",
        // pointId: null!,
        isOutofService: false,
        isPickingOnMap: false,
        selectedLocations: {
          caption: null!,
          point: null!,
        },
      };

      return state;
    },
    updateSelectedLocation: (state, action) => {
      state.selectedLocations.caption = action.payload.caption;
      state.selectedLocations.point = action.payload.point;
      return state;
    },
    setCenter: (state, action: PayloadAction<Point>) => {
      state.center = action.payload;
      return state;
    },
    setIsDraggable: (state, action: PayloadAction<boolean>) => {
      state.isDraggable = action.payload;
      return state;
    },
    // setAddress: (state, action: PayloadAction<string>) => {
    //   state.address = action.payload;
    //   return state;
    // },
    // setMapRef: (state, action) => {
    //   state.mapRef = action.payload;
    //   return state;
    // },
    // setPointId: (state, action) => {
    //   state.pointId = action.payload;
    //   return state;
    // },
    setIsOutofService: (state, action: PayloadAction<boolean>) => {
      state.isOutofService = action.payload;
      return state;
    },
    setIsPickingOnMap: (state, action: PayloadAction<boolean>) => {
      state.isPickingOnMap = action.payload;
      return state;
    },
  },
});

export default mapSlice;
